export default "__VITE_ASSET__C01usNTS__"